import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import http from '../../utils/api/http';

export const getEmailDrivers = createAsyncThunk(
    'settings/getEmailDrivers',
    async () => {
        const { data } = await http.get('api/v1/email-drivers');
        return data.data;
    },
);

export const getEmailDriver = createAsyncThunk(
    'settings/getEmailDriver',
    async (id) => {
        const { data } = await http.get(`api/v1/email-driver/${id}`);
        return data.data;
    },
);

export const createEmailDriver = createAsyncThunk(
    'settings/createEmailDriver',
    async (body, { rejectWithValue }) => {
        try {
            const { data } = await http.post('api/v1/email-driver', body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const updateEmailDriver = createAsyncThunk(
    'settings/updateEmailDriver',
    async ({ id, body }, { rejectWithValue }) => {
        try {
            const { data } = await http.put(`api/v1/email-driver/${id}`, body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const deleteEmailDriver = createAsyncThunk(
    'settings/deleteEmailDriver',
    async (id, { rejectWithValue }) => {
        try {
            await http.delete(`api/v1/email-driver/${id}`);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const getSmsDrivers = createAsyncThunk(
    'settings/getSmsDrivers',
    async () => {
        const { data } = await http.get('api/v1/sms-drivers');
        return data.data;
    },
);

export const getSmsDriver = createAsyncThunk(
    'settings/getSmsDriver',
    async (id) => {
        const { data } = await http.get(`api/v1/sms-driver/${id}`);
        return data.data;
    },
);

export const createSmsDriver = createAsyncThunk(
    'settings/createSmsDriver',
    async (body, { rejectWithValue }) => {
        try {
            const { data } = await http.post('api/v1/sms-driver', body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const updateSmsDriver = createAsyncThunk(
    'settings/updateSmsDriver',
    async ({ id, body }, { rejectWithValue }) => {
        try {
            const { data } = await http.put(`api/v1/sms-driver/${id}`, body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const deleteSmsDriver = createAsyncThunk(
    'settings/deleteSmsDriver',
    async (id, { rejectWithValue }) => {
        try {
            await http.delete(`api/v1/sms-driver/${id}`);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const getSlackDrivers = createAsyncThunk(
    'settings/getSlackDrivers',
    async () => {
        const { data } = await http.get('api/v1/slack-drivers');
        return data.data;
    },
);

export const getSlackDriver = createAsyncThunk(
    'settings/getSlackDriver',
    async (id) => {
        const { data } = await http.get(`api/v1/slack-driver/${id}`);
        return data.data;
    },
);

export const createSlackDriver = createAsyncThunk(
    'settings/createSlackDriver',
    async (body, { rejectWithValue }) => {
        try {
            const { data } = await http.post('api/v1/slack-driver', body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const updateSlackDriver = createAsyncThunk(
    'settings/updateSlackDriver',
    async ({ id, body }, { rejectWithValue }) => {
        try {
            const { data } = await http.put(`api/v1/slack-driver/${id}`, body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const deleteSlackDriver = createAsyncThunk(
    'settings/deleteSlackDriver',
    async (id, { rejectWithValue }) => {
        try {
            await http.delete(`api/v1/slack-driver/${id}`);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const getPushDrivers = createAsyncThunk(
    'settings/getPushDrivers',
    async () => {
        const { data } = await http.get('api/v1/push-drivers');
        return data.data;
    },
);

export const getPushDriver = createAsyncThunk(
    'settings/getPushDriver',
    async (id) => {
        const { data } = await http.get(`api/v1/push-driver/${id}`);
        return data.data;
    },
);

export const createPushDriver = createAsyncThunk(
    'settings/createPushDriver',
    async (body, { rejectWithValue }) => {
        try {
            const { data } = await http.post('api/v1/push-driver', body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const updatePushDriver = createAsyncThunk(
    'settings/updatePushDriver',
    async ({ id, body }, { rejectWithValue }) => {
        try {
            const { data } = await http.put(`api/v1/push-driver/${id}`, body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const deletePushDriver = createAsyncThunk(
    'settings/deletePushDriver',
    async (id, { rejectWithValue }) => {
        try {
            await http.delete(`api/v1/push-driver/${id}`);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const getPolicies = createAsyncThunk(
    'settings/getPolicies',
    async () => {
        const { data } = await http.get('api/v1/policies');
        return data.data;
    },
);

export const updateTermsOfUse = createAsyncThunk(
    'settings/updateTermsOfUse',
    async (body) => {
        await http.post('api/v1/policies/terms-of-use', body);
    },
);

export const updatePrivacyPolicy = createAsyncThunk(
    'settings/updatePrivacyPolicy',
    async (body) => {
        await http.post('api/v1/policies/privacy-policy', body);
    },
);

export const getApiKeys = createAsyncThunk('settings/getApiKeys', async () => {
    const { data } = await http.get('api/v1/api_key');
    return data.data;
});

export const createApiKey = createAsyncThunk(
    'settings/createApiKey',
    async (body, { rejectWithValue }) => {
        try {
            const { data } = await http.post('api/v1/api_key', body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const updateApiKey = createAsyncThunk(
    'settings/updateApiKey',
    async ({ id, body }, { rejectWithValue }) => {
        try {
            const { data } = await http.post(`api/v1/api_key/${id}`, body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const deleteApiKey = createAsyncThunk(
    'settings/deleteApiKey',
    async (id) => {
        await http.delete(`api/v1/api_key/${id}`);
    },
);

const initialState = {
    emailDriversLoadingStatus: 'idle',
    smsDriversLoadingStatus: 'idle',
    pushDriversLoadingStatus: 'idle',
    slackDriversLoadingStatus: 'idle',
    policiesLoadingStatus: 'idle',
    apiKeysLoadingStatus: 'idle',
    emailDrivers: [],
    smsDrivers: [],
    pushDrivers: [],
    slackDrivers: [],
    policies: [],
    apiKeys: [],
    errors: {},
};

export const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {},
    extraReducers: {
        [getEmailDrivers.pending]: (state, action) => {
            state.emailDriversLoadingStatus = 'loading';
        },
        [getEmailDrivers.fulfilled]: (state, action) => {
            state.emailDriversLoadingStatus = 'succeeded';
            state.emailDrivers = action.payload;
        },
        [getEmailDrivers.rejected]: (state, action) => {
            state.emailDriversLoadingStatus = 'failed';
        },
        [getSmsDrivers.pending]: (state, action) => {
            state.smsDriversLoadingStatus = 'loading';
        },
        [getSmsDrivers.fulfilled]: (state, action) => {
            state.smsDriversLoadingStatus = 'succeeded';
            state.smsDrivers = action.payload;
        },
        [getSmsDrivers.rejected]: (state, action) => {
            state.smsDriversLoadingStatus = 'failed';
        },
        [getSlackDrivers.pending]: (state, action) => {
            state.slackDriversLoadingStatus = 'loading';
        },
        [getSlackDrivers.fulfilled]: (state, action) => {
            state.slackDriversLoadingStatus = 'succeeded';
            state.slackDrivers = action.payload;
        },
        [getSlackDrivers.rejected]: (state, action) => {
            state.slackDriversLoadingStatus = 'failed';
        },
        [getPushDrivers.pending]: (state, action) => {
            state.pushDriversLoadingStatus = 'loading';
        },
        [getPushDrivers.fulfilled]: (state, action) => {
            state.pushDriversLoadingStatus = 'succeeded';
            state.pushDrivers = action.payload;
        },
        [getPushDrivers.rejected]: (state, action) => {
            state.pushDriversLoadingStatus = 'failed';
        },
        [getPolicies.pending]: (state, action) => {
            state.policiesLoadingStatus = 'loading';
        },
        [getPolicies.fulfilled]: (state, action) => {
            state.policiesLoadingStatus = 'succeeded';
            state.policies = action.payload;
        },
        [getPolicies.rejected]: (state, action) => {
            state.policiesLoadingStatus = 'failed';
        },
        [getApiKeys.pending]: (state, action) => {
            state.apiKeysLoadingStatus = 'loading';
        },
        [getApiKeys.fulfilled]: (state, action) => {
            state.apiKeysLoadingStatus = 'succeeded';
            state.apiKeys = action.payload;
        },
        [getApiKeys.rejected]: (state, action) => {
            state.apiKeysLoadingStatus = 'failed';
        },
    },
});

/* Selectors */
export const allEmailDrivers = (state) => state.settings.emailDrivers;
export const emailDriversLoadingStatus = (state) =>
    state.settings.emailDriversLoadingStatus;
export const allSmsDrivers = (state) => state.settings.smsDrivers;
export const smsDriversLoadingStatus = (state) =>
    state.settings.smsDriversLoadingStatus;
export const allPushDrivers = (state) => state.settings.pushDrivers;
export const pushDriversLoadingStatus = (state) =>
    state.settings.pushDriversLoadingStatus;
export const allSlackDrivers = (state) => state.settings.slackDrivers;
export const slackDriversLoadingStatus = (state) =>
    state.settings.slackDriversLoadingStatus;
export const allPolicices = (state) => state.settings.policies;
export const policicesLoadingStatus = (state) =>
    state.settings.policiesLoadingStatus;
export const allApiKeys = (state) => state.settings.apiKeys;
export const apiKeysLoadingStatus = (state) =>
    state.settings.apiKeysLoadingStatus;

export default settingsSlice.reducer;
